import { IntlShape } from 'react-intl';

import { TAccessStatus } from '@/shared/models/access-status';

const renderStatus = (intl: IntlShape, status: TAccessStatus): string => {
  switch (status) {
    case 'expired_docs':
      return intl.formatMessage({
        defaultMessage: 'Expired documents',
        id: 'CRUMf/',
        description: 'user access status',
      });
    case 'active':
      return intl.formatMessage({
        defaultMessage: 'Active',
        id: '8EHCFU',
        description: 'user access status',
      });
    // Offboarded chauffeurs are intentionally displayed as blocked
    case 'blocked':
    case 'to_be_offboarded':
    case 'offboarded':
      return intl.formatMessage({
        defaultMessage: 'Blocked',
        id: 'WhfbvD',
        description: 'user access status',
      });
    case 'partner_blocked':
      return intl.formatMessage({
        defaultMessage: 'Partner blocked',
        id: '9I+vB7',
        description: 'user access status',
      });
    case 'failed_tests':
      return intl.formatMessage({
        defaultMessage: 'Failed tests',
        id: '/mwJYF',
        description: 'user access status',
      });
    case 'pending':
      return intl.formatMessage({
        defaultMessage: 'Pending approval',
        id: 'yLqv3w',
        description: 'user access status',
      });
    case 'rejected':
      return intl.formatMessage({
        defaultMessage: 'Rejected',
        id: 'IvvbfX',
        description: 'user access status',
      });
    case 'new_partner':
    case 'end_of_life':
      return '-';
  }
};

export { renderStatus };
